import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.75 15.5C5.33578 15.5 5 15.1642 5 14.75L5.00002 5.75C5.00002 5.33579 5.33581 5 5.75002 5L14.75 5C15.1642 5 15.5 5.33579 15.5 5.75C15.5 6.16421 15.1642 6.5 14.75 6.5L7.56068 6.5L17.7803 16.7197C18.0732 17.0125 18.0732 17.4874 17.7803 17.7803C17.4874 18.0732 17.0126 18.0732 16.7197 17.7803L6.50002 7.56066L6.5 14.75C6.5 15.1642 6.16421 15.5 5.75 15.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowUpLeft;
